import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var normalizeRows = function normalizeRows(rows) {
  return rows.map(function (row) {
    Object.keys(row).forEach(function (key) {
      return row[normalizeText(key)] = row[key];
    });
    return row;
  });
};
var normalizeColumns = function normalizeColumns(columns) {
  return columns.map(function (column) {
    var property = column.property;
    return _objectSpread(_objectSpread({}, column), {}, {
      originalProperty: column.property,
      property: normalizeText(property)
    });
  });
};
var normalizeText = function normalizeText(text) {
  return text.replace(/\s+/g, '');
};

export { normalizeColumns, normalizeRows, normalizeText };
//# sourceMappingURL=normalizeData.js.map
